import { SearchBar, Toast } from '@mtfe/sweet-components';
import { loadLogin, getOadParams } from '@mtfe/pr-oad';
import { dom, eventBus, loadScript } from '@mtfe/sweet-utils';
import { reportLog, getPageName, getErrorMessage, createUnionId } from '@mtfe/sweet-report';
import store from '../store/index';
import http from '../service/index';
import autoLogin from './autoLogin';

const { storeCommon } = store;
export const clickToReport = async (poiInfo, componentID = '') => {
    try {
        const url = componentID ? `${poiInfo.clickMonitorUrl}&componentId=${componentID}` : poiInfo.clickMonitorUrl;
        await http.actGeClkM(url);
    } catch (error) {
        console.error('点击上报失败', error);
    }
};
export const useAutoLogin = (cb) => {
    return function (...args) {
        const autoLoginOptions = {
            cb,
            phone: storeCommon.phone,
            loginSuccessCb: () => {
                eventBus.$emit('loginSuccess', true);
            },
        };

        autoLogin(autoLoginOptions, {}, args);
    };
};

/**
 * 初始化用户信息
 * @returns
 */
export const initUserInfo = async () => {
    try {
        const userInfo = await http.getUserInfo();
        if (userInfo && userInfo.data) {
            const { phone = '' } = userInfo.data;
            storeCommon.phone = phone;
        }
    } catch (error) {
        console.error('获取用户信息失败', error);
    }
};

export const calcDuration = (curTime) => curTime - window.onInitTime;

// 开启搜索功能
export const openSearchFeature = () => {
    const { struct } = storeCommon.structInfo;
    const { dom_wm_search: domWmSearch } = struct;
    // 开启搜索功能
    if (domWmSearch.isShow) {
        const autoLoginOptions = {
            phone: storeCommon.phone,
            loginSuccessCb: () => {
                eventBus.$emit('loginSuccess', true);
            },
        };

        dom.$id('searchBar').innerHTML = SearchBar({
            autoLoginProps: { autoLoginOptions, urlParams: {} },
            autoLogin,
            loadLogin,
        });
    }
};

/**
 * 处理错误信息的函数。
 *
 * @param {unknown} error 可能是任何类型的错误信息，包括 Error 对象、包含错误信息的对象、字符串或其他未知类型。
 * @param {Object} [options] 选项对象。
 * @param {boolean} [options.showMessage=false] 是否显示错误信息的提示，默认为 false。如果为 true，则使用 Message.info 显示错误信息。
 * @param {boolean} [options.showConsole=true] 是否在控制台输出错误信息，默认为 true。
 */
export function handleError(error, options) {
    const { showMessage = false, showConsole = true, position = 'bottom' } = options || {};

    const errorMessage = getErrorMessage(error);

    if (showConsole) {
        console.error(error);
    }

    if (showMessage) {
        Toast({ message: errorMessage, position });
    }
}

/**
 * 将像素值转换为视窗宽度百分比的函数。
 *
 * @param {number} px 需要转换的像素值。
 * @returns {number} 转换后的视窗宽度百分比值。
 */
export const pxToVw = (px) => {
    const vw = (px / 750) * 100;
    return vw;
};

/**
 * 将750px转换为当前设备屏幕宽度下的像素值。
 *
 * @param {number} px 需要转换的像素值。
 * @returns {number} 转换后的当前设备屏幕宽度下的像素值。
 */
export const pxToCurrentPx = (px) => {
    // 获取当前设备的屏幕宽度
    const screenWidth = window.innerWidth;
    // 750 标准下的 px 转换为当前机型下的 px
    const currentPx = (px / 750) * screenWidth;
    return currentPx;
};

/**
 * 获取微信小程序HTML模板的函数。
 *
 * @param {number} height 微信小程序启动按钮的高度，单位为px。
 * @returns {string} 返回微信小程序启动按钮的HTML模板字符串。
 */
export const getWXAppHtml = (height) => {
    const tpl = `<wx-open-launch-weapp id="launch-btn1" username="gh_9fb67116bbcc"
            style="position:absolute;top:0;left:0;right:0;bottom:0;"
            path="pages/index/index?wxp=a234f07416f34550b7cda9d464e40ebc">
        <template>
            <style>
                .btn {
                    width: 100%;
                    height: ${pxToCurrentPx(height)}px;
                }
            </style>
            <div class="btn"></div>
        </template>
    </wx-open-launch-weapp>`;

    return tpl;
};

export const getWxAuthorize = (afterAuth) => {
    const apis =
        'checkJsApi,onMenuShareTimeline,onMenuShareAppMessage,onMenuShareQQ,onMenuShareWeibo,onMenuShareQZone,startRecord,stopRecord,onVoiceRecordEnd,playVoice,pauseVoice,stopVoice,onVoicePlayEnd,uploadVoice,downloadVoice,chooseImage,previewImage,uploadImage,downloadImage,getLocalImgData,translateVoice,getNetworkType,openLocation,getLocation,hideOptionMenu,showOptionMenu,hideMenuItems,showMenuItems,hideAllNonBaseMenuItem,showAllNonBaseMenuItem,closeWindow,scanQRCode,chooseWXPay,openAddress,openProductSpecificView,addCard,chooseCard,openCard,startSearchBeacons,stopSearchBeacons,onSearchBeacons,launchMiniProgram,miniProgram,updateAppMessageShareData,updateTimelineShareData,launchApplication';

    window.jsonpWXLoader = function (res) {
        const config = {
            debug: false,
            appId: 'wxc72f01f43da0083b',
            timestamp: res.data.timestamp,
            signature: res.data.signature,
            nonceStr: res.data.nonceStr,
            jsApiList: apis.split(','),
            openTagList: ['wx-open-launch-weapp'],
        };
        wx.config(config);
    };

    wx.ready(() => {
        afterAuth && afterAuth();
    });

    loadScript(`//ihotel.meituan.com/topcube/api/toc/weixin/getConfig?url=${encodeURIComponent(window.location.href)}&callback=jsonpWXLoader`);
};

export const invokeReportLog = async () => {
    const rest = await getOadParams();
    const pageName = getPageName();
    const unionId = createUnionId(pageName, { phone: storeCommon.phone, rootPvId: rest.rootPvId });

    let count = 0;

    // 立即执行函数实现递归
    (function startUp() {
        count += 1;

        if (count > 6) {
            // 最多上报6次，终止递归
            return;
        }

        reportLog({ unionId });

        // 每5秒递归调用一次
        setTimeout(() => {
            startUp();
        }, 5000);
    })();
};
